<template>
    <div class="mapBox">
        <div class="map_qq">
            <div id='mapContainer'></div>
            <audio id="mapAudioPlayer" ref="audio" style="display: none;">
                <source src="http://cauc-anniversary.oss-cn-zhangjiakou.aliyuncs.com/static/zgmhdxxg.mp3" type="audio/mpeg">
            </audio>
            <img class="zhuanfa" src="@/assets/zhuanfa.png" @click="transmit" alt="">
            <img class="map_sound" :src="isPlaying?require('@/assets/map_sound.png'):require('@/assets/map_no_sound.png')" alt="" @click="handleSound">
            <img class="map_message" src="@/assets/map_message.png" @click="openMessage" alt="">
        </div>
        <message-dialog v-model="showM"></message-dialog>
        <div class="footer">
            <div class="footer-user">
                <div class="user">
                    <div class="user-left">
                        <van-image
                                round
                                width="66px"
                                height="66px"
                                :src="form.headimgurl"
                        />
                        <div class="user-des">
                            <div class="user-title">
                                <div>{{form.name}}</div>
                                <div class="user_light_info" @click="openActive">点亮信息></div>
                            </div>
                            <div class="user-time">{{form.latest+"点亮归途"}}</div>
                        </div>
                    </div>
                    <div class="user-right" @click="toPersonal">
                        <span>我的信息 ></span>
                        <!--<img src="@/assets/right_arrow_icon.png" alt="">-->
                    </div>
                </div>
                <div v-if="showHelp" class="donation">
                  <div class="donation_item" @click="directDonat">直接捐赠</div>
                    <div class="donation_item">
                        <!--一起捐-->
                        <wx-open-launch-weapp
                id="launch-btn"
                username="gh_e68944f845f7"
                path="pages/web/webview.html?shared=false&shareTitle=false&url=donate%2Flist"
                @launch="handleLaunch"
                @error="handleError"
        >
            <script type="text/wxtag-template">
                <style>
                  .btn {
                        width: 155px;
                        height: 42px;
                        /* 删掉line-height，改用flex居中 */
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-radius: 10px;
                        color: #00A0E9;
                        font-size: 16px;
                        font-weight: 600; /* 和直接捐赠保持一致字重 */
                        box-sizing: border-box;
                        position: relative;
                        top:1px;
                      }
                </style>
                <div class="btn" style="font-size: 16px;">校友公益</div>
            </script>
         </wx-open-launch-weapp>
                    </div>
                </div>
              <div class="help_total" v-if="!showHelp" @click="showHelp=true">助力母校&nbsp;&nbsp;&nbsp;为爱续航</div>
              <div class="light-again" @click="lightAgain">再次点亮</div>
            </div>
        </div>
        <van-overlay :show="showTrans">
            <div class="wrapper" @click.stop>
                <div class="block">
                    <img class="goback" src="@/assets/trans_back_icon.png" alt="" @click="goBack">
                    <div class="save_pic" id="capture">
                        <div class="left_block">
                            <div class="part1">
                                <van-image
                                        round
                                        width="66px"
                                        height="66px"
                                        crossorigin="anonymous"
                                        :src="form.headimgurl"
                                />
                                <div class="part1_right">
                                    <div class="right_name">{{form.name}}</div>
                                    <div class="right_light">
                                        <div class="light_des">我是第<span>{{sequence}}</span>位点亮的中航大人，你也快来参加吧</div>
                                        <!--<div>人，你也快来参加吧</div>-->
                                    </div>
                                </div>
                            </div>
                            <!--<div class="part2"></div>-->
                            <div class="part3"><img src="../../assets/school_logo_new.png" alt=""></div>
                        </div>
                        <div class="saoma">
                            <div class="yundianliang"><img src="../../assets/yundianliang.png" alt=""></div>
                            <div class="img"><img src="../../assets/erweima.png" alt=""></div>
                            <div class="saoma_title">扫码参与活动</div>
                        </div>
                    </div>
                    <div id="printDiv">
                        <img :src="dataUrl"/>
                    </div>
                    <div class="save_alert">长按保存图片</div>
                </div>
            </div>
        </van-overlay>
        <van-overlay :show="showConfigInfo">
            <div class="wrapper" @click.stop>
                <div class="config_info">
                    <img class="config_delete" src="@/assets/config_delete_icon.png" @click="closeConfig" alt="">
                    <div class="config_part1">
                        <div class="part1_left">您是第</div>
                        <div class="part1_middle">{{sequence}}</div>
                        <div class="part1_right">位参与者</div>
                    </div>
                    <div class="config_part2">合计点亮 <span>{{count}}</span> 次</div>
                    <div class="config_part3">
                        <div>感谢您参与中航大云点亮活动</div>
                        <!--<div>云点亮活动</div>-->
                    </div>
                    <div class="config_part4">
                        <img src="@/assets/school_logo_new.png" alt="">
                    </div>
                </div>
            </div>
        </van-overlay>
    </div>
</template>

<script>
import {weixinInfo, lightCity, getWxConfig, lightPoints, lightSequence} from '../../utils/ajaxInterface'
import {Dialog} from 'vant'
import html2canvas from 'html2canvas'
import MessageDialog from '../message'

var wx = window.wx
var markerClusterer = null
var map = null
var schoolMarker = null
var planeMarker = null
var planeAnimationFrame = null
export default {
  name: 'index',
  components: {MessageDialog, html2canvas},
  data () {
    return {
      sequence: 0,
      count: 0,
      showConfigInfo: false,
      showTrans: false,
      form: {name: '', headimgurl: '', latest: ''},
      myPosions: [],
      otherPosions: [],
      dataUrl: '',
      showHelp: false,
      isPlaying: false,
      showM: false
    }
  },
  beforeDestroy () {
    this.clearPlaneAnimation()
    const audio = this.$refs.audio
    if (audio) {
      audio.pause()
    }
    sessionStorage.removeItem('iosReload')
  },
  mounted () {
    if (/iPhone|iPad|iPod/.test(navigator.userAgent)) {
      if (!sessionStorage.getItem('iosReload')) {
        sessionStorage.setItem('iosReload', '1')
        location.reload()
        return
      }
    }
    // this.initMap()//做测试用
    this.$nextTick(() => {
      // this.getInfo()
      getWxConfig().then(() => {
        // 先通过详情的最后点亮时间判断是否点亮
        this.getInfo()
      })
    })
  },
  methods: {
    closeConfig () {
      this.showConfigInfo = false
    },
    goBack () {
      this.showTrans = false
    },
    handleSound () {
      const audio = this.$refs.audio
      if (!audio) {
        return
      }
      if (this.isPlaying) {
        audio.pause()
      } else {
        audio.play()
      }
      this.isPlaying = !this.isPlaying
    },
    openMessage () {
      this.showM = true
    },
    downloadImg () {
      let that = this
      html2canvas(document.querySelector('#capture'), {
        allowTaint: true, useCORS: true
      }).then(function (canvas) {
        that.dataUrl = canvas.toDataURL('image/png')
        document.getElementById('printDiv').style.display = 'block'
        document.getElementById('capture').style.display = 'none'
      })
    },
    transmit () {
      this.showTrans = true
      this.$nextTick(() => {
        if (!this.dataUrl) {
          this.downloadImg()
        }
      })
    },
    handleLaunch () {
      console.log('跳转成功')
    },
    handleError (e) {
      console.error('跳转失败', e.detail)
    },
    lightAgain () {
      let that = this
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84',
          success: (res) => {
            var point = new BMap.Point(res.longitude, res.latitude)
            var gc = new BMap.Geocoder()
            gc.getLocation(point, function (rs) {
              var addComp = rs.addressComponents
              // console.log(addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber)
              let params = {lng: res.longitude, lat: res.latitude, address: addComp.province + addComp.city}
              let currentPoint = new BMap.Point(res.longitude, res.latitude)
              lightCity(params).then(res => {
                if (!res.result) {
                  that.getLightSequence()
                  that.flyPlane(currentPoint, () => {
                    that.showConfigInfo = true
                  })
                  let overlays = map.getOverlays()
                  overlays.forEach(item => {
                    map.removeOverlay(item)
                  })
                  markerClusterer.clearMarkers()
                  that.clusterer()
                  return
                }
                Dialog.alert({
                  title: '提示',
                  message: res.result || '点亮成功'
                }).then(() => {
                  if (!res.result) {
                    that.getLightSequence()
                    that.flyPlane(currentPoint)
                    // map.clearOverlays()
                    let overlays = map.getOverlays()
                    overlays.forEach(item => {
                      map.removeOverlay(item)
                    })
                    markerClusterer.clearMarkers() // 此步骤需要
                    that.clusterer()
                  }
                })
              }).catch(e => {
                this.$toast.fail(e)
              })
            })
          },
          fail: (err) => {
            alert('获取位置失败')
            console.error('获取位置失败:', err)
          }
        })
      })
    },
    getInfo () {
      weixinInfo().then(res => {
        if (!res.latest) {
          res.latest = ''
          this.form = res
          // 没有点亮请去点亮
          this.startLight()
        } else {
          this.form = res
          this.initMap()
          this.getLightSequence()
        }
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    startLight () {
      this.initMap()
      let that = this
      // let currentPoint = new BMap.Point(80.82,39.24)
      // that.flyPlane(currentPoint)
      wx.ready(() => {
        wx.getLocation({
          type: 'wgs84',
          success: (res) => {
            var point = new BMap.Point(res.longitude, res.latitude)
            var gc = new BMap.Geocoder()
            gc.getLocation(point, function (rs) {
              var addComp = rs.addressComponents
              // console.log(addComp.province + addComp.city + addComp.district + addComp.street + addComp.streetNumber)
              let params = {lng: res.longitude, lat: res.latitude, address: addComp.province + addComp.city}
              let currentPoint = new BMap.Point(res.longitude, res.latitude)
              lightCity(params).then(res => {
                if (!res.result) {
                  that.getLightSequence()
                  that.flyPlane(currentPoint, () => {
                    that.showConfigInfo = true
                  })
                  weixinInfo().then(res => {
                    that.form = res
                  })
                  markerClusterer.clearMarkers()
                  that.clusterer()
                  return
                }
                Dialog.alert({
                  title: '提示',
                  message: res.result || '点亮成功'
                }).then(() => {
                  if (!res.result) {
                    that.getLightSequence()
                    that.flyPlane(currentPoint)
                    weixinInfo().then(res => {
                      that.form = res
                    })
                    markerClusterer.clearMarkers() // 此步骤需要
                    that.clusterer()
                  }
                })
              }).catch(e => {
                this.$toast.fail(e)
              })
            })
          },
          fail: (err) => {
            console.error('获取位置失败:', err)
          }
        })
      })
    },
    getLightSequence () {
      lightSequence().then(res => {
        this.sequence = res.sequence
        this.count = res.count
      })
    },
    directDonat () {
      // this.$toast.fail('暂不能使用')
      this.$router.push('/donation')
    },
    toPersonal () {
      this.$router.push('/personalCenter')
    },
    addSchoolMarker () {
      if (!map) {
        return
      }
      if (schoolMarker) {
        map.removeOverlay(schoolMarker)
      }
      let schoolPoint = new BMap.Point(117.3523, 39.109123)
      let schoolIcon = new BMap.Icon(
        require('../../assets/minhang_logo.png'),
        new BMap.Size(40, 40),
        {
          anchor: new BMap.Size(20, 20),
          imageSize: new BMap.Size(40, 40)
        }
      )
      schoolMarker = new BMap.Marker(schoolPoint, {icon: schoolIcon})
      schoolMarker.setZIndex(90)
      map.addOverlay(schoolMarker)
    },
    clearPlaneAnimation () {
      if (planeAnimationFrame) {
        cancelAnimationFrame(planeAnimationFrame)
        planeAnimationFrame = null
      }
      if (planeMarker && map) {
        map.removeOverlay(planeMarker)
      }
      planeMarker = null
    },
    flyPlane (startPoint, onComplete) {
      if (!map || !startPoint) {
        return
      }
      this.clearPlaneAnimation()

      let endPoint = new BMap.Point(117.3523, 39.109123)
      let startPixel = map.pointToPixel(startPoint)
      let endPixel = map.pointToPixel(endPoint)
      let deltaX = endPixel.x - startPixel.x
      let deltaY = endPixel.y - startPixel.y
      let direction = Math.atan2(deltaY, deltaX)
      let directionAngle = direction * 180 / Math.PI
      let isLeftOfSchool = deltaX >= 0
      let planeWidth = 56
      let planeHeight = 40
      let planeBaseAngle = isLeftOfSchool ? 0 : 180
      let planeRotation = (directionAngle - planeBaseAngle + 540) % 360 - 180
      let planeEndPixel = endPixel
      let planeTravelX = planeEndPixel.x - startPixel.x
      let planeTravelY = planeEndPixel.y - startPixel.y
      let planeTravelDistance = Math.sqrt(planeTravelX * planeTravelX + planeTravelY * planeTravelY)
      let planeSpeed = 80
      let planeIcon = new BMap.Icon(
        require(isLeftOfSchool ? '../../assets/map-plane-right.png' : '../../assets/map-plane-left.png'),
        new BMap.Size(planeWidth, planeHeight),
        {
          anchor: new BMap.Size(planeWidth / 2, planeHeight / 2),
          imageSize: new BMap.Size(planeWidth, planeHeight)
        }
      )
      let duration = Math.max(planeTravelDistance / planeSpeed * 1000, 1)
      let startTime = 0

      let animate = (timestamp) => {
        if (!startTime) {
          startTime = timestamp
        }
        let progress = Math.min((timestamp - startTime) / duration, 1)
        let currentPixel = new BMap.Pixel(
          startPixel.x + planeTravelX * progress,
          startPixel.y + planeTravelY * progress
        )
        planeMarker.setPosition(map.pixelToPoint(currentPixel))

        if (progress < 1) {
          planeAnimationFrame = requestAnimationFrame(animate)
        } else {
          if (onComplete) {
            onComplete()
          }
          let arrivedPlaneMarker = planeMarker
          let fadeStartTime = 0
          let fadeDuration = 1000
          let fadeOut = (fadeTimestamp) => {
            if (!fadeStartTime) {
              fadeStartTime = fadeTimestamp
            }
            let fadeProgress = Math.min((fadeTimestamp - fadeStartTime) / fadeDuration, 1)
            if (arrivedPlaneMarker.setOpacity) {
              arrivedPlaneMarker.setOpacity(1 - fadeProgress)
            }
            if (fadeProgress < 1) {
              planeAnimationFrame = requestAnimationFrame(fadeOut)
            } else {
              planeAnimationFrame = null
              map.removeOverlay(arrivedPlaneMarker)
              if (planeMarker === arrivedPlaneMarker) {
                planeMarker = null
              }
            }
          }
          planeAnimationFrame = requestAnimationFrame(fadeOut)
        }
      }

      planeAnimationFrame = requestAnimationFrame(() => {
        planeMarker = new BMap.Marker(startPoint, {icon: planeIcon})
        planeMarker.setZIndex(110)
        planeMarker.setRotation(planeRotation)
        map.addOverlay(planeMarker)
        planeAnimationFrame = requestAnimationFrame(animate)
      })
    },
    clusterer () {
      lightPoints().then(res => {
        this.addSchoolMarker()
        let result = res
        let myPosions = result.filter(item => item.myself)
        let otherPosions = result.filter(item => !item.myself)
        let defaultIcon = new BMap.Icon(require('../../assets/heart_icon.png'), new BMap.Size(32, 32))
        let defaultIcon1 = new BMap.Icon(require('../../assets/myself_icon.png'), new BMap.Size(45, 45))
        let markers1 = []
        let markers2 = []
        myPosions.forEach((item) => {
          var pt = new BMap.Point(item.lng, item.lat)
          var marker = new BMap.Marker(pt, {icon: defaultIcon1})
          marker.setZIndex(100) // 按数组顺序设置层级
          map.addOverlay(marker)
          markers1.push(marker)
          // markers1.setAnimation(BMAP_ANIMATION_BOUNCE)
          // 创建标签并设置内容
          let img = `<div style="background: url(${this.form.headimgurl}) no-repeat center center;width: 20px;height: 20px;background-size: 100% 100%;border-radius: 10px"></div>`
          var label = new BMap.Label(img, {
            position: pt, // 设置文本标注所在的地理位置
            offset: new BMap.Size(-11, -16) // 设置标签的偏移量
          })
          label.setStyle({
            backgroundColor: 'transparent',
            border: 'none',
            color: '#fff'
          })
          // 添加标签到地图上
          map.addOverlay(label)
        })
        otherPosions.forEach((item) => {
          var pt = new BMap.Point(item.lng, item.lat)
          var marker = new BMap.Marker(pt, {icon: defaultIcon})
          marker.setZIndex(80) // 按数组顺序设置层级
          map.addOverlay(marker)
          markers2.push(marker)
        })

        markerClusterer = new BMapLib.MarkerClusterer(map, {
          markers: markers2,
          gridsize: 100, // 聚集网格大小
          styles: [
            {
              url: require('../../assets/heart_1.png'),
              size: new window.BMap.Size(40, 40),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_2.png'),
              size: new window.BMap.Size(45, 45),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_3.png'),
              size: new window.BMap.Size(50, 50),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_4.png'),
              size: new window.BMap.Size(55, 55),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_5.png'),
              size: new window.BMap.Size(60, 60),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_6.png'),
              size: new window.BMap.Size(70, 70),
              textColor: '#ffffff'
            },
            {
              url: require('../../assets/heart_7.png'),
              size: new window.BMap.Size(80, 80),
              textColor: '#ffffff'
            }
          ]
        })
        setTimeout(() => {
          map.setZoom(map.getZoom()) // 强制刷新当前视图
        }, 100)
      }).catch(e => {
        this.$toast.fail(e)
      })
    },
    initMap () {
      // 创建地图实例
      // const map = new BMap.Map('mapContainer')
      // 百度地图API功能
      map = new BMap.Map('mapContainer')
      map.centerAndZoom(new BMap.Point(114.01, 32.60), 5)
      map.enableScrollWheelZoom()
      map.setMapStyleV2({
        styleId: 'a971d3c78797902b0d75aa7fa020abb3'
      })
      this.addSchoolMarker()
      this.clusterer()
    },
    openActive () {
      this.showConfigInfo = true
    }
  }
}
</script>

<style scoped lang="less">
    .mapBox {
        width: 100%;
        height: 100vh;

        .map_qq {
            height: 100vh;
            position: relative;
            .zhuanfa,.map_sound,.map_message{
                position: absolute;
                width: 24px;
                height: 24px;
                top: 30px;
                z-index: 1;
            }
          .zhuanfa{
            right: 78px;
          }
          .map_sound{
            right: 44px;
          }
          .map_message{
            right: 10px;
          }
            #mapContainer {
                width: 100%;
                height: 100vh;
            }
        }

        .footer {
            position: fixed;
            left: 0;
            bottom: 0;
          right: 0;
            width: 100%;
            height: 285px;
            background: url("../../assets/map_user_bg.png") no-repeat center center;
          background-size: 100% 100%;
            padding: 56px 10px 0;
            /*border-radius:8px;*/
            box-sizing: border-box;

            .footer-user {
                width: 100%;
                height: 208px;
                /*background: #3C5387;*/
                border-radius: 10px;
                padding: 15px 15px 0;
                box-sizing: border-box;
                /*margin-bottom: 14px;*/

                .user {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    /*padding-bottom: 14px;*/
                    box-sizing: border-box;
                    margin-bottom: 20px;

                    .user-left {
                        display: flex;
                        align-items: center;

                        img {
                            width: 66px;
                            height: 66px;
                        }

                        .user-des {
                            margin-left: 9px;
                            width: 150px;
                            .user-title {
                                font-size: 18px;
                                color: #000000;
                                display: flex;
                                justify-content: space-between;
                                align-items: center;
                                .user_light_info{
                                    font-weight: 400;
                                    font-size: 13px;
                                    color: #00A0E9;
                                    text-decoration-line: underline;
                                }
                            }

                            .user-time {
                                font-weight: 500;
                                font-size: 14px;
                                color: #444444;
                                margin-top: 6px;
                            }
                        }
                    }

                    .user-right {
                        width: 96px;
                        height: 30px;
                        background: #FFFFFF;
                        border-radius: 32px;
                        justify-content: center;
                        font-weight: 500;
                        font-size: 12px;
                        color: #00A0E9;
                        display: flex;
                        align-items: center;

                        img {
                            width: 5px;
                            height: 9px;
                            margin-left: 4px;
                        }
                    }

                }

                .donation {
                    display: flex;
                    justify-content: space-between;

                    .donation_item {
                      width: 155px;
                      height: 42px;
                      line-height: 42px;
                      text-align: center;
                      font-size: 15px;
                      font-weight: 600; //新增
                      color: #00A0E9;
                      border-radius: 10px;
                      border: 1px solid #00A0E9;
                      box-sizing: border-box;
                    }
                }
            }
          .help_total{
            width: 100%;
            height: 42px;
            font-weight: bold;
            line-height: 42px;
            text-align: center;
            font-size: 16px;
            color: #00A0E9;
            border-radius: 10px;
            border: 1px solid #00A0E9;
          }

            .light-again {
              width: 100%;
              height: 42px;
              margin-top: 13px;
                line-height: 42px;
                background: linear-gradient( 270deg, #0067DD 0%, #66ADFF 100%);;
                border-radius: 10px;
                text-align: center;
                color: #ffffff;
                font-size: 20px;
                font-weight: 700;
            }
        }
    }
    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
    }

    .block {
        width: 100%;
        min-height: 100%;
        /*background: url("../../assets/trans_bg.png") center center no-repeat;*/
        /*background-size: cover;*/
        padding: 10px 16px 0;
        box-sizing: border-box;
        .goback{
            width: 23px;
            height: 23px;
        }
        .save_pic{
            background: url("../../assets/trans_inner_bg.png") center center no-repeat;
            background-size: cover;
            margin-top: 10px;
            width: 100%;
            height: 574px;
            padding: 443px 20px 20px;
            box-sizing: border-box;
            display: flex;
            align-items: end;
            .left_block{
                width: calc(100% - 74px);
                .part1{
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;
                    .img{
                        width: 66px;
                        height: 66px;
                        background-size: 100% 100%;
                    }
                    .part1_right{
                        flex: 1;
                        margin-left: 10px;
                        .right_name{
                            font-weight: 500;
                            font-size: 20px;
                            color: #000000;
                        }
                        .right_light{
                            font-weight: 400;
                            font-size: 12px;
                            color: #333333;
                            margin-top: 6px;
                          .light_des{
                            span{
                              margin: 0 2px;
                              color: #00A0E9;
                            }
                          }
                        }
                    }
                }
                .part3{
                    margin-top:17px ;
                    img{
                        width: 160px;
                        height: 24px;
                    }
                }
            }
            .saoma{
                text-align: center;
                width: 74px;
                font-size: 12px;
                color: #999999;
                .yundianliang{
                    text-align: center;
                    img{
                        width: 60px;
                        height: 29px;
                    }

                  margin-bottom: -10px;
                }
                .img{
                    text-align: center;
                    width: 74px;
                    height: 74px;
                    img{
                        width: 74px;
                        height: 74px;
                    }
                }
                .saoma_title{
                    /*margin-top: 5px;*/
                }
            }
        }
        #printDiv{
            margin-top: 10px;
            width:100%;
            height:574px;
            display: none;
            img{
                width:100%;
                height:574px;
            }
        }
        .save_alert{
            margin-top: 10px;
            text-align: center;
            color: #ffffff;
            font-size: 14px;
        }
    }
    .config_info{
        position: relative;
        width: 278px;
        height: 383px;
        background: url("../../assets/config_info_bg.png") no-repeat center center;
        background-size: 100% 100%;
        padding: 204px 0 0;
        box-sizing: border-box;
        color: #444444;
        text-align: center;
        .config_delete{
            position: absolute;
            left: 50%;
            bottom: -42px;
            transform: translateX(-20px);
            width: 40px;
            height: 40px;
        }
        .config_part1{
            display: flex;
            justify-content: center;
            align-items: center;
            height: 26px;
            font-weight: 400;
            font-size: 16px;
            color: #444444;
            margin-bottom: 7px;
            .part1_middle{
                width: 60px;
                /*border-bottom: 4px solid #999999;*/
                text-align: center;
                font-weight: 700;
                font-size: 24px;
                color: #00A0E9;
                margin: 0 4px;
            }
        }
        .config_part2{
            font-size: 16px;
            margin-bottom: 10px;
            span{
                color: #5277E7;
            }
        }
        .config_part3{
            font-weight: 600;
          font-size: 13px;
          color: #00A0E9;
            line-height: 24px;
            margin-bottom: 16px;
        }
        .config_part4{
            img{
                width: 160px;
                height: 24px;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/map/index.vue